import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useMilestoneEdition } from "@planzone/view-models";
import { MilestoneCompletion } from "../milestoneCompletion";
import { Props } from "./types";
import { NameForm } from "./nameForm";
import { MilestoneIcon } from "@common/milestoneIcon";
import { RichTextInput } from "@common/richTextInput";
import styles from "./styles.scss";

function Details({ milestone, project, readOnly }: Props) {
  const { t } = useTranslation();
  const [description, setDescription] = React.useState(milestone.description);
  const { isRequestPending, editMilestone } = useMilestoneEdition(milestone);
  const [isEditable, setIsEditable] = React.useState(false);
  const toggleTitleModification = () => setIsEditable(!isEditable);

  return (
    <div className={classNames(styles.details)}>
      <div className={styles.header}>
        <MilestoneCompletion
          milestone={milestone}
          isEditable={!project.isTemplate && !readOnly}
        />
        <MilestoneIcon className={styles.icon} milestone={milestone} />
        <div className={styles.title}>
          {!readOnly && isEditable ? (
            <NameForm milestone={milestone} hide={toggleTitleModification} />
          ) : (
            <h1 className={styles.name} onClick={toggleTitleModification}>
              {milestone.name}
            </h1>
          )}
        </div>
      </div>
      <div className={styles.description}>
        <h3 className={styles.label}>{t("milestoneRetrieval.description")}</h3>
        <RichTextInput
          value={description || ""}
          maxLength={10000}
          placeholder={t("milestoneRetrieval.description")}
          input={setDescription}
          onChange={() =>
            !isRequestPending &&
            editMilestone({
              milestone,
              nextMilestone: { ...milestone, description },
            })
          }
          isDisabled={readOnly}
        />
      </div>
    </div>
  );
}

export { Details };
